import { pick } from 'lodash'

import { EditSchema } from '../../../schemas/editSchema'
import { Variables } from './types'

export const mapper = (data: EditSchema): Variables => {
  return {
    ...pick(data, [
      'customVariableName',
      'customVariableTriggerEnabled',
      'customVariableValue',
      'id',
      'matchType',
      'name',
      'onlySendAdRequestsForAssignedAdUnits',
      'path',
      'pathTriggerEnabled',
    ]),
    adUnitIds: data.adUnitIds.right,
  }
}
